import React from 'react'
import PropTypes from 'prop-types'

const ButtonAvatarRepo = ({ value, label, selectedValue, onChange, rounded }) => {
  const isSelected = selectedValue === value

  return (
    <label className={`cursor-pointer ${rounded === 'left' ? '' : '-ml-[2px]'}`}>
      <input
        type="radio"
        hidden
        value={value}
        onChange={(e) => onChange(e.target.value)}
        checked={isSelected}
      />
      <span
        className={`${
          isSelected ? 'text-white bg-house-pink' : 'text-house-text-gray bg-soft-gray'
        } hover:opacity-80 px-4 py-1 text-sm font-medium border-collapse border-2 border-white ${
          rounded === 'left' ? 'rounded-l-full' : rounded === 'right' ? 'rounded-r-full' : ''
        } shadow hover:shadow-lg transition-shadow duration-200`}
      >
        {label}
      </span>
    </label>
  )
}

ButtonAvatarRepo.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selectedValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  rounded: PropTypes.oneOf(['left', 'right', 'none'])
}

ButtonAvatarRepo.defaultProps = {
  rounded: 'none'
}

export default ButtonAvatarRepo
